

//arr1 will be the user's roles
//arr2 
export const checkPermission = (userRoles, can, editableOriIds, oriId, incidentId) => {
  if (incidentId?.includes("Offline_")) {
    return true
  } else {
    const roleOk = checkRoles(userRoles, can) || isSuperUser(userRoles)
    const oriIsOk = (editableOriIds === "ALL" || !oriId || isSuperUser(userRoles)) ? true : editableOriIds?.includes(oriId?.toString())
    return (!!roleOk && !!oriIsOk)
  }
}

export const checkRoles = (roleNames, can) => {
  const arr2 = CAPABILITIES?.[can]
  if (roleNames && arr2) {
    return roleNames.some(item => arr2.includes(item?.toUpperCase())) || isSuperUser(roleNames)
  } else {
    // alert(`${arr1 ? "" : "User roles"} ${arr2 ? "" : "Capability name"} not found`)
    return false;
  }
}

export const shouldBeLocked = (localDisabled, localCanEdit) => {
  // if (isSuperUser(roles)) {
  //   return false
  // } else {
    const overrideDisable = localDisabled !== null && localDisabled !== undefined ? localDisabled : null
    const lockByRules = localCanEdit !== null && localCanEdit !== undefined ? (localCanEdit ? false : true) : true
    return overrideDisable !== null && overrideDisable !== undefined ? overrideDisable : lockByRules
  // }
}

// export const isSuperUser = (userObj) => !!userObj?.roles?.find(role => role.name === "Super_User")
export const isSuperUser = (roles = []) => {
  const upperCaseRoles = roles?.map(r => r?.toUpperCase())
  return upperCaseRoles?.includes("SUPER_USER")
}


// const isSupervisor = (roles) => roles?.includes("Sup" || "SUP")

export const isDispatcher = (roles = []) => {
  const upperCaseRoles = roles?.map(r => r?.toUpperCase())
  return upperCaseRoles?.includes("DISPATCH")
}

export const canEditAvailableOfficers = (user, oriToEdit, officerId) => {
  const hasRole = checkRoles(user?.roleNames, "edit_ofc_status")
  if (user?.id?.toString() === officerId?.toString()) {
    //can edit self
    return true
  } else if (hasRole && user?.editableOriIds.includes(oriToEdit?.toString())) {
    //check if the user is a supervisor and their editable ORI ids includes the officer's ORI id
    return true
  } else {
    return false
  }
}

export const CAPABILITIES = {
  edit_ofc_status: ["SUPERVISOR", "DISPATCH", "ADMIN"],
  view_incidents_within_ori: ["OFFICER", "ADMIN", "RECORDS", "SUP", "DISPATCH"],
  create_incidents_within_ori: ["OFFICER", "ADMIN", "RECORDS", "SUP", "DISPATCH"],
  view_incidents_across_oris: ["OFFICER", "ADMIN", "RECORDS", "SUP", "DISPATCH"],
  create_incidents_across_oris: ["ADMIN", "DISPATCH", "CROSS_ORI_USER"],
  run_nibrs: ["ADMIN", "RECORDS", "NIBRS"],
  view_usage: ["ADMIN", "RECORDS"],
  edit_incident: ["OFFICER", "ADMIN", "RECORDS", "SUP", "DISPATCH", "CROSS_ORI_USER"],
  edit_other_ori_incident: ["SUPER_USER", "CROSS_ORI_USER"],
  lock_incident: ["ADMIN", "RECORDS", "SUP"],
  view_locked_incident: ["ADMIN", "RECORDS", "SUP"],
  edit_locked_incident: [],
  seal_incident: ["ADMIN", "RECORDS"],
  view_sealed_incident: ["ADMIN", "RECORDS"],
  edit_attachment_info: ["ADMIN", "RECORDS", "PROPERTY_MANAGER"],
  view_confidential_attachments: ["ADMIN", "RECORDS", "SUP"],
  keep_session_forever: ["ADMIN", "RECORDS", "DISPATCH"],
  dispatch_officers: ["ADMIN", "RECORDS", "DISPATCH", "SUP", "SUPER_USER", "CROSS_ORI_USER"],
  approve_incident: ["ADMIN", "SUP"],
  edit_locked_cc: ["ADMIN"],
  delete_cc: ["ADMIN"],
  edit_property_tag: ["ADMIN", "PROPERTY_MANAGER", "RECORDS"],
  delete_property: ["ADMIN"],
  delete_attachment: ["ADMIN", "RECORDS"],
  expunge: ["ADMIN", "RECORDS"],
  submit_for_prosecution: ["ADMIN", "SUP", "RECORDS", "CROSS_ORI_USER", "PROSECUTION_MRG"],
  cancel_incident: ["ADMIN", "RECORDS", "SUP", "DISPATCH"],
  save_new_incident: ["ADMIN", "DISPATCH"],
  add_related_incident: ["ADMIN", "DISPATCH"],
  view_setup: ["OFFICER", "ADMIN", "RECORDS", "SUP", "DISPATCH"],
  view_audit_logs: ["ADMIN", "SUPER_USER"],
  edit_prosecution_data: ["ADMIN", "RECORDS", "PROSECUTION_EDITOR"],
  edit_violations: ["SUPER_USER", "VIOLATIONS_MGR", "ADMIN"],
  set_nibrs_property: ["ADMIN", "RECORDS", "OFFICER", "DISPATCH", "SUP", "PROPERTY_MANAGER", "RECORDS_INTAKE"],
  manage_all_nibrs: ["NIBRS_ADMIN", "SUPER_USER"],
  change_incident_disposition: ["SUP", "ADMIN", "OFFICER", "RECORDS"],
  reset_officer_timer: ["ADMIN", "DISPATCH"],
  edit_offense_ibr_designation: ["ADMIN", "RECORDS", "NIBRS", "SUP"],
  edit_setup: ["ADMIN", "SUPER_USER"],
  edit_dispatch_setup: ["ADMIN", "RECORDS", "DISPATCH"],
  edit_skills: ["ADMIN", "RECORDS", "SUP", "DISPATCH"],
  // edit_officer_narratives: ["ADMIN", "SUP", "RECORDS"],
  edit_officer_narratives: ["RECORDS"],
  add_dispatch_narratives: ["ADMIN", "DISPATCH"],
  add_query_returns: ["ADMIN", "DISPATCH", "RETURN_USER"],
  view_query_returns: ["ADMIN", "DISPATCH", "RETURN_USER", "OFFICER", "SUP"],
  view_records_queue: ["ADMIN", "RECORDS_INTAKE", "RECORDS", "PROCESS"],
  inactivate_officer: ["ADMIN"],
  // this includes the CLI
  set_officer_responses: ["ADMIN", "SUP", "DISPATCH"],
  remove_bulletin_ori: ["ADMIN", "SUP", "DISPATCH", "RECORDS"],
  unlock_ticket: ["ADMIN", "SUP", "RECORDS"],
  zip_incidents: ["ADMIN", "RECORDS"],
  edit_setup_list: ["ADMIN"],
  edit_all_setup_lists: ["SUPER_USER"],
  use_car_stop: ["ADMIN", "OFFICER"],
  send_bulletins: ["ADMIN", "DISPATCH", "SUP", "RECORDS", "RESPONSER"],
  collapse_expand: ["ADMIN", "DISPATCH", "SUPER_USER"],
  submit_to_crash: ["ADMIN", "RECORDS", "DISPATCH", "OFFICER"],
  edit_across_oris: ["SUPER_USER", "CROSS_ORI_USER"],
  merge_names: ["SUPER_USER", "NAME_MERGE"],
  edit_review_comments: ["ADMIN", "DISPATCH", "SUP", "RECORDS"],
  view_pin: ["ADMIN", "SUPER_USER"],
  submit_to_jb: ["ETICKET_USER", "SUPER_USER"],
  resubmit_to_jb: ["SUPER_USER", "VIOLATIONS_MGR"],
  edit_addresses: ["ADMIN", "DISPATCH", "SUP", "RECORDS"],
  set_password: ["PASSWORD_MGR", "ADMIN"],
  self_dispatch: ["SELF_DISPATCH"],
  loan_officers: ["ADMIN", "DISPATCH", "SUP"],
  approve_uof: ["UOF_REVIEWER"],
  search_training_records: ["ADMIN", "TRAINING_MGR"],
  filter_incident: ["ADMIN"],
  unlock_sw: ["SUP", "ADMIN"],
  edit_dev_id_sub_ori: ["ADMIN"],
}